import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

export default {
    name: 'UserProfile',
    computed,
    data,
    methods,
    mounted
}
